import type { UseQueryExecute } from '@urql/next'
import { useQuery } from '@urql/next'
import { createContext, useContext } from 'react'
import { graphql } from '@/generated/gql'
import type { RecordingsQuery } from '@/generated/gql/graphql'
import { SortEnumType } from '@/generated/gql/graphql'
import { useMeeting } from '@/utils/state/meeting-room'

export const GET_MEETING_RECORDINGS = graphql(`query Recordings(
    $input: QueryRecordingsInput!,
    $order: [AttachmentSortInput!],
  ) {
    recordings(
      input: $input,
      order: $order,
    ) {
        id
        title
        size
        order
        meetingId
        attachmentPath
        transcriptionStatus
  }
}
`)

type RecordingContext = {
    fetching: boolean
    recordingsData: RecordingsQuery
    getRecordings: UseQueryExecute
}
const recordingContext = createContext<RecordingContext>({
    fetching: false,
    recordingsData: null,
    getRecordings: () => {},
})

const RecordingProvider = ({ children }) => {
    const [meeting] = useMeeting()

    const [{ data: recordingsData, fetching }, getRecordings] = useQuery({
        query: GET_MEETING_RECORDINGS,
        variables: {
            input: {
                meetingId: meeting?.id,
            },
            order: {
                order: SortEnumType.Asc,
            },
        },
        pause: true,
        requestPolicy: 'network-only',
    })

    return (
        <recordingContext.Provider
            value={{ recordingsData, fetching, getRecordings }}
        >
            {children}
        </recordingContext.Provider>
    )
}

const useRecordings = () => {
    return useContext(recordingContext)
}

export { RecordingProvider, useRecordings }
